import { roundHalfUp, summarizeOvertimeBreakdown } from '@sit/core';
export function toWeeklyBreakdownByTimeType(overtimeBreakdown) {
    const { breakdownByTimeType, hasDiscrepancies, hasOvertimeData } = summarizeOvertimeBreakdown(overtimeBreakdown);
    // Convert map to array and return the correctly applied weekly breakdown
    const weeklyBreakdown = Array.from(breakdownByTimeType.values().map((entry) => ({
        ...entry,
        underappliedDuration: entry.incorrectlyAppliedDuration < 0
            ? entry.incorrectlyAppliedDuration * -1
            : 0,
        overappliedDuration: entry.incorrectlyAppliedDuration > 0
            ? entry.incorrectlyAppliedDuration
            : 0,
    })));
    return {
        weeklyBreakdown,
        hasOvertimeData,
        hasDiscrepancies,
    };
}
export function formatOvertimeDuration(seconds) {
    const hours = seconds / 3600;
    return roundHalfUp(hours, 2).toFixed(2);
}
export function formatOvertimeDurationForVariance(breakdown) {
    const underOverText = breakdown.underappliedDuration > 0
        ? `-${formatOvertimeDuration(breakdown.underappliedDuration)}`
        : breakdown.overappliedDuration > 0
            ? `+${formatOvertimeDuration(breakdown.overappliedDuration)}`
            : breakdown.underappliedDuration < 0
                ? `+${formatOvertimeDuration(breakdown.underappliedDuration * -1)}`
                : breakdown.overappliedDuration < 0
                    ? `-${formatOvertimeDuration(breakdown.overappliedDuration * -1)}`
                    : '0.00';
    return underOverText;
}
//# sourceMappingURL=overtime.js.map